var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-8 pt-2 m-4"},[_c('v-card',{attrs:{"id":"summary-card"}},[_c('v-row',[_c('v-col',[_c('h4',{staticClass:"ml-12 p-2 elevation-2",attrs:{"id":"summary-badge"}},[_vm._v("Summary")])])],1),_c('v-card-text',{staticClass:"text-center"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }